import { InjectionToken } from '@angular/core';

import { SocketHandlerStore } from '../types';

export const DEFAULT_SOCKET_HANDLER: SocketHandlerStore = {
  dashboardEvent: null,
  submissionListEvent: null,
  submissionDetailEvent: null,
  submissionDocumentEvent: null,
};

export const SOCKET_HANDLER_INJECTION_CONTEXT =
  new InjectionToken<SocketHandlerStore>('SOCKET_HANDLER_INJECTION_CONTEXT', {
    factory: () => ({ ...DEFAULT_SOCKET_HANDLER }),
  });
